export enum SortType {
  recent = "asc",
  old = "desc",
  abc = "abc",
  random = "random",
}
